var _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81641 42.4398V9.05346C1.97315 6.7023 3.69733 2 9.34009 2C14.9829 2 31.4409 2 38.9646 2L49.7799 12.8153V42.4398",
    stroke: "#5956E9",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4947 25.2771H21.2733C20.7901 25.2771 20.3266 25.0851 19.9849 24.7434C19.6431 24.4017 19.4512 23.9382 19.4512 23.455C19.4512 22.9717 19.6431 22.5082 19.9849 22.1665C20.3266 21.8248 20.7901 21.6328 21.2733 21.6328H39.4947C39.978 21.6328 40.4415 21.8248 40.7832 22.1665C41.1249 22.5082 41.3169 22.9717 41.3169 23.455C41.3169 23.9382 41.1249 24.4017 40.7832 24.7434C40.4415 25.0851 39.978 25.2771 39.4947 25.2771Z",
    fill: "#E541ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4943 32.5642H13.9843C13.501 32.5642 13.0375 32.3722 12.6958 32.0305C12.3541 31.6888 12.1621 31.2253 12.1621 30.7421C12.1621 30.2588 12.3541 29.7953 12.6958 29.4536C13.0375 29.1119 13.501 28.9199 13.9843 28.9199H39.4943C39.9775 28.9199 40.441 29.1119 40.7827 29.4536C41.1244 29.7953 41.3164 30.2588 41.3164 30.7421C41.3164 31.2253 41.1244 31.6888 40.7827 32.0305C40.441 32.3722 39.9775 32.5642 39.4943 32.5642Z",
    fill: "#E541ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2057 39.8533H13.9843C13.501 39.8533 13.0375 39.6613 12.6958 39.3196C12.3541 38.9779 12.1621 38.5144 12.1621 38.0311C12.1621 37.5479 12.3541 37.0844 12.6958 36.7427C13.0375 36.401 13.501 36.209 13.9843 36.209H32.2057C32.6889 36.209 33.1524 36.401 33.4941 36.7427C33.8358 37.0844 34.0278 37.5479 34.0278 38.0311C34.0278 38.5144 33.8358 38.9779 33.4941 39.3196C33.1524 39.6613 32.6889 39.8533 32.2057 39.8533Z",
    fill: "#E541ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4941 3.88086V13.7557H48.369",
    stroke: "#5956E9",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.90625,
    y: 47.2305,
    width: 47.7849,
    height: 11.1069,
    stroke: "#5956E9",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFallback);
export default __webpack_public_path__ + "static/media/cardFallback.54ab8a54244594d647a4f145242470c9.svg";
export { ForwardRef as ReactComponent };